export default __webpack_public_path__ + "static/media/readingBook.0cb003ea.svg";